/* Angry Boy — Tactical theme behavior.
   Nav scroll state, mobile panel, hero typewriter, count-up stats,
   and scroll-reveal. All guarded so a removed section can't throw.
   Honors prefers-reduced-motion. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Nav scroll ──────────────────────────────────────── */
  var nav = document.getElementById('mainNav');
  if (nav) {
    var onScroll = function () {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile panel ────────────────────────────────────── */
  var hamburger    = document.getElementById('hamburger');
  var mobilePanel  = document.getElementById('mobilePanel');
  var panelOverlay = document.getElementById('panelOverlay');

  if (hamburger && mobilePanel && panelOverlay) {
    var openPanel = function () {
      mobilePanel.classList.add('open');
      panelOverlay.classList.add('open');
      hamburger.classList.add('open');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    var closePanel = function () {
      mobilePanel.classList.remove('open');
      panelOverlay.classList.remove('open');
      hamburger.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };
    hamburger.addEventListener('click', function () {
      mobilePanel.classList.contains('open') ? closePanel() : openPanel();
    });
    panelOverlay.addEventListener('click', closePanel);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });
  }

  /* ── Typewriter ──────────────────────────────────────── */
  var twEl = document.getElementById('twWord');
  if (twEl) {
    /* Typed by JS, so the i18n text-walker can't reach these. Keep both lists
       here and swap on the ab:lang event fired by ab-i18n.js. */
    var WORDS = {
      en: ['DOMINANT', 'TACTICAL', 'UNSTOPPABLE', 'FEARLESS', 'LETHAL'],
      ar: ['مسيطر', 'تكتيكي', 'جامد', 'شجاع', 'فتّاك']
    };
    var words = document.documentElement.classList.contains('ab-ar') ? WORDS.ar : WORDS.en;
    var wIdx = 0, cIdx = 0, deleting = false;

    document.addEventListener('ab:lang', function (e) {
      words = (e.detail === 'ar') ? WORDS.ar : WORDS.en;
      wIdx = 0; cIdx = 0; deleting = false;
      twEl.textContent = reduced ? words[0] : '';
    });

    if (reduced) {
      twEl.textContent = words[0];
    } else {
      (function tick() {
        var word = words[wIdx];
        twEl.textContent = deleting ? word.slice(0, cIdx - 1) : word.slice(0, cIdx + 1);
        if (!deleting) cIdx++; else cIdx--;
        if (!deleting && cIdx === word.length) {
          setTimeout(function () { deleting = true; setTimeout(tick, 60); }, 2200);
          return;
        }
        if (deleting && cIdx === 0) {
          deleting = false;
          wIdx = (wIdx + 1) % words.length;
        }
        setTimeout(tick, deleting ? 55 : 95);
      })();
    }
  }

  /* ── Count-up ────────────────────────────────────────── */
  function countUp(el, target, suffix) {
    if (reduced) {
      el.textContent = (target >= 1000 ? target.toLocaleString() : target) + suffix;
      return;
    }
    var dur = 1800;
    var t0 = performance.now();
    (function frame(now) {
      var p = Math.min((now - t0) / dur, 1);
      var v = Math.round(p < 0.5 ? 2 * p * p * target : (1 - Math.pow(-2 * p + 2, 2) / 2) * target);
      el.textContent = (target >= 1000 ? v.toLocaleString() : v) + suffix;
      if (p < 1) requestAnimationFrame(frame);
    })(t0);
  }

  /* ── IntersectionObserver: reveal + count-up ─────────── */
  var revealEls = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window) || reduced) {
    revealEls.forEach(function (el) {
      el.classList.add('visible');
      el.querySelectorAll('[data-count]').forEach(function (num) {
        countUp(num, parseInt(num.dataset.count, 10), num.dataset.suffix || '');
      });
    });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      el.classList.add('visible');
      el.querySelectorAll('[data-count]').forEach(function (num) {
        countUp(num, parseInt(num.dataset.count, 10), num.dataset.suffix || '');
      });
      if (el.dataset.count) {
        countUp(el, parseInt(el.dataset.count, 10), el.dataset.suffix || '');
      }
      io.unobserve(el);
    });
  }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

  revealEls.forEach(function (el) { io.observe(el); });
})();
